import session from '../session'

var uri = process.env.API_ENDPOINT

export default {
  //////////////////////////////////////////
  // ベース情報関連
  /**
   * サイトマップ用ロボ一覧取得
   */
  getSitemapRoboList () {
    console.debug('***** Called getSitemapRoboList *****')
    return session.get(uri + '/api/user/sitemap/get_sitemap_robo_list/')
  },
  /**
   * ホームページ用タグ一覧取得
   * @param {Number} selectedSitemapRoot 選択中サイトマップPK
   */
  getHomePageTagList (selectedSitemapRootPk) {
    console.debug('***** Called getHomePageTagList *****')
    return session.get(uri + '/api/user/sitemap/get_sitemap_tag_list/' + selectedSitemapRootPk + '/')
  },
  /**
   * 求人ページ用タグ一覧取得
   */
  getEmploymentTagList () {
    console.debug('***** Called getEmploymentTagList *****')
    return session.get(uri + '/api/user/sitemap/get_employment_tag_list/')
  },
  //////////////////////////////////////////
  // サイトマップルート関連
  /**
   * 自動作成待ちサイトマップルート取得
   */
  getSitemapWaitList () {
    console.debug('***** Called getSitemapWaitList *****')
    return session.get(uri + '/api/user/sitemap/sitemap_wait/')
  },
  /**
   * サイトマップルート登録
   * @param {String} registSitemapUrl 新規サイトマップルートURL
   */
  registSitemapWait (registSitemapUrl) {
    console.debug('***** Called registSitemapRoot *****')
    return session.post(uri + '/api/user/sitemap/sitemap_wait/', registSitemapUrl )
  },
  /**
   * サイトマップルート削除
   * @param {Object} sitemapWait 削除待機中サイトマップルートPK
   */
  deleteSitemapWait (sitemapWait) {
    console.debug('***** Called deleteSitemapWait *****')
    return session.delete(uri + '/api/user/sitemap/sitemap_wait/' + sitemapWait.sitemap_wait_pk + '/')
  },
  /**
   * サイトマップルートリスト取得
   */
  getSitemapRootList () {
    console.debug('***** Called getSitemapRootList *****')
    return session.get(uri + '/api/user/sitemap/sitemap_root/')
  },
  /**
   * サイトマップルート削除
   * @param {Object} sitemapRoot 削除サイトマップルートPK
   */
  deleteSitemapRoot (sitemapRoot) {
    console.debug('***** Called deleteSitemapRoot *****')
    return session.delete(uri + '/api/user/sitemap/sitemap_root/' + sitemapRoot.sitemap_root_pk + '/')
  },
  //////////////////////////////////////////
  // サイトマップノード関連
  /**
   * サイトマップノード追加
   * @param {Object} addNodeData 追加サイトマップノード情報
   */
  addSitemapNode (addNodeData) {
    console.debug('***** Called addSitemapNode *****')
    return session.post(uri + '/api/user/sitemap/sitemap_node/', addNodeData)
  },
  /**
   * サイトマップノード更新
   * @param {Object} updateNodeData  更新サイトマップノード情報
   */
  updateSitemapNode (updateNodeData) {
    console.debug('***** Called updateSitemap *****')
    return session.put(uri + '/api/user/sitemap/sitemap_node/', updateNodeData)
  },
  /**
   * サイトマップノード削除
   * @param {Object} sitemapNode 削除サイトマップノード情報
   */
  deleteSitemapNode (sitemapNode) {
    console.debug('***** Called deleteSitemapNode *****')
    return session.delete(uri + '/api/user/sitemap/sitemap_node/' + sitemapNode.node_pk + '/')
  },
  //////////////////////////////////////////
  // サイトマップ求人ページ関連
  /**
   * 求人ページリスト取得
   * @param {Object} getInfo 取得ページ情報
   */
  getSitemapRecruitList (getInfo) {
    console.debug('***** Called getSitemapRecruitList *****')
    return session.get(uri + '/api/user/sitemap/sitemap_employment/' + getInfo.pages + '/' + getInfo.per_page + '/' + getInfo.content_type + '/')
  },
  /**
   * 全求人ページリスト取得
   * @param {Object} getInfo 取得ページ情報
   */
  getSitemapRecruitListAll (contentType) {
    console.debug('***** Called getSitemapRecruitListAll *****')
    return session.get(uri + '/api/user/sitemap/sitemap_employment/0/0/' + contentType + '/')
  },
  /**
   * カスタムページリスト取得
   * @param {Object} getInfo 取得ページ情報
   */
  getSitemapCustomList (getInfo) {
    console.debug('***** Called getSitemapCustomList *****')
    return session.get(uri + '/api/user/sitemap/sitemap_employment/' + getInfo.pages + '/' + getInfo.per_page + '/' + getInfo.content_type + '/')
  },
  /**
   * 全カスタムページリスト取得
   * @param {Object} getInfo 取得ページ情報
   */
  getSitemapCustomListAll (contentType) {
    console.debug('***** Called getSitemapCustomListAll *****')
    return session.get(uri + '/api/user/sitemap/sitemap_employment/0/0/' + contentType + '/')
  },
  /**
   * 求人ページおよびカスタムページ取得
   * @param {Object} updateData 更新求人ページ情報 
   */
  getSitemapEmploymentListAll () {
    console.debug('***** Called getSitemapEmploymentListAll *****')
    return session.get(uri + '/api/user/sitemap/sitemap_employment/')
  },
  /**
   * 求人ページおよびカスタムページ更新
   * @param {Object} updateData 更新求人ページ情報 
   */
  updateSitemapEmployment (updateData) {
    console.debug('***** Called updateSitemapEmployment *****')
    return session.put(uri + '/api/user/sitemap/sitemap_employment/', updateData)
  },
  //////////////////////////////////////////
  // ロボ表示順関連
  getSitemapRoboOrder (sitemap_id) {
    console.debug('***** Called getSitemapRoboOrder *****')
    return session.get(uri + '/api/user/sitemap/sitemap_robo_order/' + sitemap_id + '/')
  },
  updateSitemapRoboOrder (roboOrder) {
    console.debug('***** Called updateSitemapRoboOrder *****')
    return session.put(uri + '/api/user/sitemap/sitemap_robo_order/', roboOrder)
  },
  //////////////////////////////////////////
  // タグ関連
  /**
   * タグ更新
   * @param {Object} addTagData 追加タグ情報
   */
  addSitemapTag (addTagData) {
    console.debug('***** Called addSitemapTag *****')
    return session.post(uri + '/api/user/sitemap/sitemap_tag/', addTagData)
  },
  /**
   * タグ削除
   * @param {Object} sendData 削除タグPK
   */
  deleteSitemapTag (sendData) {
    console.debug('***** Start ***** deleteSitemapTag')
    return session.delete(uri + '/api/user/sitemap/sitemap_tag/' + sendData.tag_pk + '/' + sendData.is_str_recruit + '/' + sendData.pages + '/' + sendData.per_page + '/' + sendData.content_type + '/')
  },
  /**
   * 一括タグ編集
   * @param {Object}} sendData 
   */
  editAllSitemapTag (sendData) {
    console.debug('***** Start ***** editAllSitemapTag')
    return session.put(uri + '/api/user/sitemap/sitemap_tag/', sendData)
  }
}



// WEBPACK FOOTER //
// ./src/api/users/sitemapApi.js